/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { object, bool, func, shape } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import p from 'polyglot/polyglot';

import { createUrl } from 'utils/urlHelper';

import { showSignupModal as showSignupModalAction } from 'actions/signup';

import Button from 'components/Button/Button';

import styles from './banner-block.scss';

/**
 * This is the BannerBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class BannerBlock extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    history: object.isRequired,
    auth: shape({
      isAuthenticated: bool.isRequired,
    }).isRequired,
    showSignupModal: func.isRequired,
  };

  onClickSignup = e => {
    e.preventDefault();

    const {
      auth: { isAuthenticated },
      history,
      showSignupModal,
    } = this.props;

    if (isAuthenticated) {
      return history.push(createUrl('signup'));
    }

    return showSignupModal();
  };

  /**
   * Render BannerBlock.
   *
   * @return {Object}
   */
  render() {
    return (
      <section className={styles.wrapper}>
        <header>
          <h1 className={styles.title}>{p.t('home.banner.title')}</h1>
        </header>
        <div className={styles.buttons}>
          <Button wide onClick={this.onClickSignup}>
            {p.t('signup.button.signup')}
          </Button>
        </div>
      </section>
    );
  }
}

export default withRouter(
  connect(
    ({ auth }) => ({ auth }),
    {
      showSignupModal: showSignupModalAction,
    }
  )(BannerBlock)
);
